﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";

import { toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_element } from "../codes.constants";
import { useAptitude } from "@/hooks/maintainers/aptitudes";

const AptitudesForm = ({ confirmSave, isLoadingSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, aptitude_id } = useParams();
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const [data, setData] = useState({ ...base_element });

	const { data: response, isLoading } = useAptitude(aptitude_id);

	useEffect(() => {
		if (response) {
			setData(response.detail);
		}
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/aptitudes");
	};

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Aptitud</h4>
			</Modal.Header>

			<Modal.Body>
				{isLoading || isLoadingSave ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>
								<Form.Control
									value={data ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isLoading && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || (isLoadingSave && true)}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default AptitudesForm;
